import type { AxiosError } from "axios";
import { HumanReadableErrors } from "@/App/config/messages";
import { hasMessage } from "@/App/type-guards/hasMessage";

export const HttpErrorParser = {
  parse: (axiosError: AxiosError): string | undefined => {
    if (axiosError.response) {
      if (hasMessage(axiosError.response.data)) {
        const parsedMessage = axiosError.response.data.message;

        if (parsedMessage) {
          return parsedMessage as string;
        }
      }

      return undefined;
    }

    return HumanReadableErrors.noInternetConnection;
  },
};
